<template>
  <div>
    <personnel-list v-show="tabType === 1" @handleShow="handleShow" />
    <personnel-show v-if="tabType === 2" @handleShow="handleShow" :rowItem="rowItem" />
  </div>
</template>

<script>
import personnelList from './list.vue'
import personnelShow from './show.vue'
export default {
  components: { personnelList, personnelShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>